"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var create_1 = require(36);
function withObservable(stream$) {
    return create_1.create({
        didSubscribe: function () {
            var _this = this;
            var observable = typeof stream$ === 'function'
                ? stream$(this.props, this.providers)
                : stream$;
            this._observableSubscription = observable.subscribe(function (props) { return _this.set(props); });
        },
        willDestroy: function () {
            this._observableSubscription.unsubscribe();
        },
    });
}
exports.withObservable = withObservable;
//# sourceMappingURL=withObservable.js.map